import ConfigDetailPanel from './ConfigDetailPanel'

/**
 * DetailPanelContent component renders a detailed panel for a specific row
 * in the global configuration list. It filters and displays configurations
 * related to a specific port number derived from the row's key.
 *
 * @param {Object} props - The props object.
 * @param {Object} props.row - The data for the selected row, containing a `key` property.
 * @param {Array} props.listOfConfigs - The list of all configuration objects.
 * @param {Function} props.handleEditClick - Callback function to handle edit action.
 * @param {Function} props.handleDeleteClick - Callback function to handle delete action.
 * @returns {JSX.Element} The rendered component, either a ConfigDetailPanel or a message.
 */
export default function DetailPanelContent({
  row,
  listOfConfigs,
  handleEditClick,
  handleDeleteClick,
}) {
  const portNumber = row.key.split('-')[1]
  const portConfigs = (listOfConfigs || []).filter(
    (item) =>
      item.key?.toLowerCase().startsWith(`tcp-${portNumber}`) ||
      item.key?.toLowerCase().startsWith(`monitor-${portNumber}`)
  )
  if (portConfigs.length > 0) {
    return (
      <ConfigDetailPanel
        portNumber={portNumber}
        portConfigs={portConfigs}
        handleEditClick={handleEditClick}
        handleDeleteClick={handleDeleteClick}
      />
    )
  }
  return <div style={{ padding: 16 }}>No additional details available.</div>
}
